import React from "react";
import ReactDOM from "react-dom";
import NextApp from "./NextApp";

// Patch ResizeObserver to prevent loop errors
const RO = window.ResizeObserver;
if (RO) {
  window.ResizeObserver = class ResizeObserver extends RO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Suppress the ResizeObserver loop limit exceeded error overlay
window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) resizeObserverErr.setAttribute('style', 'display: none');
    if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
});

const render = (Component) => {
  ReactDOM.render(
    <Component />,
    document.getElementById("root")
  );
};

render(NextApp);
